<button
    type="button"
    [class]="buttonClasses"
    pButton
    [label]="buttonLabel | translate"
    [icon]="buttonIcon"
    iconPos="right"
    (click)="panel.toggle($event)"
></button>

<p-popover #panel>
    <ng-template pTemplate="content">
        <div class="flex flex-col gap-4">
            @if (topText) {
                <div class="flex items-end justify-center h-6 gap-0">{{ topText }}</div>
                <p-divider class="mt-0!" />
            }
            @for (label of labels; track $index) {
                @if (functions[$index]) {
                    <ng-template #tooltipContent>
                        <div class="flex flex-col gap-1">
                            <span class="font-bold">{{ tooltips[$index] | translate }}</span>
                            @if (tooltipLinkLabels[$index]) {
                                @if (tooltipLinks[$index]) {
                                    <button
                                        type="button"
                                        pButton
                                        severity="secondary"
                                        size="small"
                                        [routerLink]="tooltipLinks[$index]"
                                        (click)="panel.hide()"
                                        class="mt-1 w-full"
                                    >
                                        {{ tooltipLinkLabels[$index] | translate }}
                                    </button>
                                } @else {
                                    <span class="text-white">{{ tooltipLinkLabels[$index] | translate }}</span>
                                }
                            }
                        </div>
                    </ng-template>
                    <div [pTooltip]="tooltipContent" [tooltipDisabled]="!disabled[$index]" tooltipPosition="left" [autoHide]="tooltipAutoHide[$index]">
                        <button
                            [attr.data-testid]="'dropdown-panel-option-' + label"
                            type="button"
                            pButton
                            pRipple
                            [class]="classes[$index] + ' mr-2'"
                            [severity]="severities[$index]"
                            [disabled]="disabled[$index]"
                            (click)="click($index)"
                            style="width: 12rem"
                        >
                            <span class="flex justify-start w-full gap-4 pl-2">
                                @if (!showSpinner[$index] && icons[$index]) {
                                    <i [class]="icons[$index]"></i>
                                } @else if (showSpinner[$index]) {
                                    <p-progressSpinner class="processing-spinner" strokeWidth="6" />
                                }
                                {{ label | translate }}
                            </span>
                        </button>
                    </div>
                }
                @if (showDividers[$index]) {
                    <p-divider />
                }
            }
        </div>
    </ng-template>
</p-popover>
